import React, { Component } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Card,
  Input,
  message,
  Select,
  Spin,
} from "antd";
import axios from "services/axios";

const FormItem = Form.Item;
const { Option } = Select;

class BusinessAreaCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      directorUsers: [],
      pricingAreas: [],
      isLoading: false,
    };
  }

  componentDidMount() {
    this.fetchAreaPricing();
    this.fetchDirector();
  }

  async fetchAreaPricing() {
    const {
      data: { areas },
    } = await axios.get(`/misc/area-pricing`);
    this.setState({ pricingAreas: areas });
  }

  async fetchDirector() {
    const {
      data: { directorUsers },
    } = await axios.get(`/misc/director-users`);
    this.setState({ directorUsers });
  }

  async createBranchArea(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      this.setState({ isLoading: true });
      if (!err) {
        axios
          .post(`/admin-panel/business-area`, values)
          .then(result => {
            message.success(`Berhasil menambah Area ${values.name}`);
            this.props.history.push(`/home/business-area`);
          })
          .catch(err => {
            this.errorMessage(err);
          });
      }
      this.setState({ isLoading: false });
    });
  }

  callback(key, props) {
    props.form.resetFields();
  }

  errorMessage(e) {
    if (e.response) {
      if (e.response.data || e.response.message) {
        message.error(
          e.response.data.message || e.response.message || e.response.data
        );
      } else {
        message.error("Error Create Area");
      }
    } else {
      message.error("Error Create Area");
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Card title="Create Business Area">
        <Spin
          tip="Sedang menambahkan Area Baru"
          spinning={this.state.isLoading}>
          <Form onSubmit={e => this.createBranchArea(e)}>
            <FormItem label="Area">
              {getFieldDecorator("area", {
                rules: [{ required: true, message: "Area wajib diisi" }],
              })(<Input />)}
            </FormItem>
            <FormItem label="ABM">
              {getFieldDecorator("directorsId")(
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select a ABM">
                  {this.state.directorUsers.map((val, index) => (
                    <Option key={index} value={val.id}>
                      {val.User ? val.User.name : ""}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
            <Row type="flex" justify="end">
              <Col>
                <Button htmlType="submit" type="primary">
                  Create
                </Button>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Card>
    );
  }
}

export default Form.create()(BusinessAreaCreate);



// WEBPACK FOOTER //
// src/components/Dashboard/Area/BusinessArea/BusinessAreaCreate.js